import { Typography, Button, Box } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import { Link as RouterLink } from "react-router-dom";
import usePickups from "hooks/pickups/usePickups";
import PickupCards from "./PickupCards";
import { useTerminology } from "hooks/useTerminology";

function Pickups() {
  let showAlert = false;
  const terminology = useTerminology();
  const {
    pickups,
    errorMessage,
    isLoading,
    getPickups,
    hasNextPage,
    deletePickup,
    incrementCurrentPage,
  } = usePickups();

  return (
    <div>
      <Box>
        <Breadcrumbs
          data={[{ label: "Home", to: "/" }, { label: terminology.Pickups }]}
        ></Breadcrumbs>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", flexWrap: "wrap", gap: 2, mt: 2 }}>
        <Button
          component={RouterLink}
          variant="contained"
          size="large"
          to="/pickups/new"
        >
          Create a {terminology.Pickup}
        </Button>
      </Box>

      <Typography
        variant="h4"
        mt={{ xs: 3, sm: showAlert ? 0 : 3 }}
        fontWeight="bold"
      >
        {terminology.Pickups}
      </Typography>

      <PickupCards
        pickups={pickups}
        errorMessage={errorMessage}
        isLoading={isLoading}
        getPickups={getPickups}
        hasNextPage={hasNextPage}
        deletePickup={deletePickup}
        incrementCurrentPage={incrementCurrentPage}
      />
    </div>
  );
}

export default Pickups;
